import type { Ref } from "vue";
import { useMediaQuery } from "@vueuse/core";

export const MOBILE_MEDIA_QUERY = "(max-width: 768px)";

export interface UseResponsiveResult {
  isMobile: Ref<boolean>;
}

/**
 * Exposes whether the viewport matches the inclusive 768px mobile breakpoint.
 * @remarks Migration: Uses VueUse useMediaQuery instead of the Vue 2 MatchMedia
 * component, preserving its matches value as isMobile. No tablet or desktop flags are added.
 * @returns A reactive isMobile flag for the original max-width: 768px query.
 */
export function useResponsive(): UseResponsiveResult {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);

  return {
    isMobile,
  };
}
